import {
  Card,
  CardContent,
  Typography,
  Chip,
  Stack,
  Box,
  Button,
} from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import React from "react";

export default function LegislationCardMobile({
  data,
  regulationType,
  handleLoadMore,
  pageSize,
  dataCount,
}) {
  const capitalizeFirstLetter = (text) => {
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
  };
  return (
    <>
      {data?.length ? (
        <>
          {data?.map((item, index) => (
            <React.Fragment key={index}>
              <Card
                sx={{
                  maxWidth: 520,
                  borderRadius: 2,
                  border: "1px solid #E0E0E0",
                  position: "relative",
                  boxShadow: "none",
                  marginBottom: "10px",
                }}
              >
                {/* Vetoed Chip */}
                <Chip
                  label={
                    item?.current_disposition ||
                    item?.passage_status ||
                    item?.status ||
                    "n/a"
                  }
                  sx={{
                    position: "absolute",
                    top: 5,
                    right: 16,
                    backgroundColor: "#FDECEC",
                    color: "#D32F2F",
                    textTransform: "capitalize",
                    fontWeight: 600,
                    fontSize: 12,
                  }}
                />

                <CardContent sx={{ p: 1 }}>
                  {/* Title */}
                  <Typography
                    sx={{
                      color: "#1E88E5",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      fontSize: 16,
                      mb: 1,
                    }}
                  >
                    {item?.reference_title
                      ? item?.reference_title
                      : regulationType === "Legislation"
                        ? `${item?.session_id}${item?.state}${item?.number}`
                        : regulationType === "Agency Docs"
                          ? `${item?.state}${item?.number}`
                          : `${item?.calendar_year}${item?.state}${item?.number}`}
                  </Typography>

                  {/* Heading */}
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: 14,
                      textTransform: "capitalize",
                      mb: 1,
                      color: "#111",
                    }}
                  >
                    {capitalizeFirstLetter(item?.title)}
                  </Typography>

                  {/* Meta Info */}
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ mb: 1, color: "#666", textTransform: "capitalize" }}
                  >
                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <DescriptionOutlinedIcon fontSize="small" />
                      <Typography fontSize={12}>{item?.track_type}</Typography>
                    </Stack>

                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <LocationOnOutlinedIcon fontSize="small" />
                      <Typography fontSize={12}>{item?.state_name}</Typography>
                    </Stack>

                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <CalendarTodayOutlinedIcon fontSize="small" />
                      <Typography fontSize={12}>
                        {item?.last_update_date}
                      </Typography>
                    </Stack>
                  </Stack>

                  {/* Description */}
                  <Typography
                    sx={{
                      fontSize: 13,
                      color: "#555",
                      mb: 2,
                      lineHeight: 1.2,
                    }}
                  >
                    {capitalizeFirstLetter(item?.summary)}
                  </Typography>

                  {/* Button */}
                  <Box>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#0B3C5D",
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: 13,
                        px: 1,
                        borderRadius: 1,
                        "&:hover": {
                          backgroundColor: "#082F46",
                        },
                      }}
                    >
                      <a
                        href={item?.public_text_link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Link to full {item?.track_type}
                      </a>
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </React.Fragment>
          ))}
        </>
      ) : null}

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {data?.length < dataCount && (
          <button
            className="button-loadmore-pagination"
            onClick={handleLoadMore}
          >
            Load More
          </button>
        )}
      </div>
    </>
  );
}
